import * as z from 'zod';
import { validationMessagesMap } from 'src/utils/messages';

export type TaxReasonFormSchemaValues = z.infer<typeof taxReasonFormSchema>;
export const taxReasonFormSchema = z.object({
    name: z.string().nonempty(),
    value: z
        .string()
        .regex(/^\d{0,20}(?:\.\d{0,4})?$/)
        .nonempty()
        .refine(
            (val) => {
                const num = Number(val);
                return num >= 0 && num <= 100;
            },
            {
                message: validationMessagesMap.validationErrorPercent,
            },
        ),
    is_active: z.boolean(),
    is_default: z.boolean(),
});
